module.exports = __webpack_public_path__ + "img/beelogo.3bd20e9b.jpg";